export const BACKEND_SERVICE_UPDATE_CURRENT_MEMBER =
  'BACKEND_SERVICE_UPDATE_CURRENT_MEMBER';

export function updateCurrentMember(currentMember) {
  return {
    type: BACKEND_SERVICE_UPDATE_CURRENT_MEMBER,
    payload: {
      currentMember,
    },
  };
}
